<div
  class="document-sync-toolbar inline-flex items-center gap-2"
  data-testid="document-sync-toolbar">
  <button
    mat-stroked-button
    type="button"
    class="!h-9 !text-sm rounded-full border-outline text-primary"
    [disabled]="!canSync || isSyncing"
    (click)="onSyncClick()"
    data-testid="document-sync-now-button">
    <mat-icon svgIcon="refresh-double" class="icon-size [--icon-size:16px] [--icon-stroke-width:2] text-on-surface-variant!"></mat-icon>
    {{ (isSyncing ? 'Syncing...' : 'Sync') | translate }}
  </button>
  <span
    class="inline-block size-2 rounded-full bg-tertiary-50 shrink-0"
    aria-hidden="true"
    data-testid="document-sync-warning-dot"></span>
  <span class="body-small text-on-surface-variant whitespace-nowrap" data-testid="document-sync-updated-label">
    {{ updatedLabel }}
  </span>
</div>
